import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/mall/card/list'
    return request.post(url,data)
}

export function all() {
    let url = '/mall/card/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/mall/card/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/mall/card/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/mall/card/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/mall/card/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/mall/card/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/mall/card/dmz/options'
    return request.get(url)
}
